import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';

import {
  RootPage,
  // CreateOrderPage,
  // OrderDetailsPage,
  // ProductionItemPage,
} from './pages';

const SeedingPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  // const organizationRoot = ROUTES.orders.organization.root;

  // const [orderToCopy, setOrderToCopy] = useState<string | undefined>();

  // const consumeOrder = (): string | undefined => {
  //   const orderId = orderToCopy;
  //   setOrderToCopy(undefined);

  //   return orderId;
  // };

  // const onOrderCopy = (orderId: string) => setOrderToCopy(orderId);

  return (
    <Switch>
      {/* <Route
        path={`${path}${ROUTES.orders.new.root}`}
      >
        <CreateOrderPage
          orderToCopy={orderToCopy}
          onOrderCopy={consumeOrder}
        />
      </Route>
      <Route path={`${path}${ROUTES.orders.details.root}`} component={OrderDetailsPage} /> */}
      <Route path={`${path}`}>
        <RootPage />
      </Route>
    </Switch>
  );
};

export default SeedingPage;
